import React from 'react';
const sassStyles = require('../ViewTemplates.scss');

export default props => {
  const {children} = props;
  return (
    <div className={sassStyles.noTemplates} style={props.style}>
      <img className={sassStyles.monster_yellow} src={require('../images/monster_yellow.svg')}/>
      <div className={sassStyles.headLine}>This Folder Is Empty</div>
      {children ? children : [
        <p key={1}>To move templates to this folder - select templates in other folders and click “MOVE TO”</p>,
        <p key={2}>or click “CREATE NEW TEMPLATE” to create a new template in this folder</p>
      ]}
    </div>
  );
};
